export default "__VITE_ASSET__1e17a310__"